import { FileStarOutlineIcon } from './FileStarOutlineIcon';

/**
 * author: Michael Miday
 * id B418C938-EE23-4073-B10C-C1D93D54B288
 * name file-star-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-star-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileFavoriteOutlineIcon = FileStarOutlineIcon;
export default FileFavoriteOutlineIcon